import './BBQ.scss';
import { useI18n } from '../i18n/i18n';

export function BBQ() {
    const t = useI18n();
    return <section id="bbq">
        <div className="next-day bold gold">2025. 06. 01.</div>
        <div>{t.bbq.text}</div>
    </section>;
}
